// extracted by mini-css-extract-plugin
export default {"container":"styles_container__SXOYm","lodingContainer":"styles_lodingContainer__Zhrk0"};